<div class="pageheader">
  <div class="page-title">
    <h1>Alert Status</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">
        <span>Refresh</span>
        <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
    </div>
  </div>
</div>

<div class="btn-toolbar">
  <ng-container *bizPermissionRequired="'Alert_Edit_Configuration'">
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="enableAlerts()" [disabled]="selectedAlertConfigurationStatuses().length < 1">Enable alerts</button>
    </div>
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" (click)="disableAlerts()" [disabled]="selectedAlertConfigurationStatuses().length < 1">Disable alerts</button>
    </div>
  </ng-container>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Alert_Action_CancelAlert'" (click)="cancelAlerts()" [disabled]="selectedAlertConfigurationStatuses().length < 1">Cancel
      alerts</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="['Alert_View_GlobalAbsence', 'Alert_Edit_GlobalAbsence']; type:'And'" (click)="absenceSchedule()">
      <span>Schedule absence</span>
      @if (isGlobalAlertAbsenceActive()) {
      &nbsp;
      <span class="badge">Active</span>
      }
      @if (isGlobalAlertAbsenceScheduled()) {
      &nbsp;
      <span class="badge">Scheduled</span>
      }
    </button>
  </div>
</div>

<app-alert-status-grid [items]="alertConfigurationStatuses()" (selectedAlertConfigurationChange)="onSelectedAlertConfigurationChange($event)"></app-alert-status-grid>
